import MdPage from '@/components/md-page.vue'; 
import MdAffix from '@/components/md-affix/index.vue';
import WholeConfirm from '@/components/whole-confirm/index.vue';

export default function registerGlobComp(vue: any) {
  vue.component('md-page', MdPage);
  vue.component('md-affix', MdAffix);
  vue.component('whole-confirm', WholeConfirm);
}
